/*
   Theme Selector
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import '../../css/JourneySelector.css'
import { setJourneyNavStep } from '../../actions/journey-actions'
import { getSelectedArtwork } from '../../selectors/journeyState-selectors'
import '../../css/JourneyPrint.css'

const ArtSummary = (props) => (
     <div className={'artwork-summary-container'}>
      {props.getSelectedArtwork.map(artwork => (
        <div className={'artwork-summary'}>
            <div className={'image-container'}>
               <img 
               key={`summary-${artwork.id}`} 
               className={`summary-image summary-${artwork.get('orientation')}`} 
               src={artwork.getIn(['artwork', 'medium', 'url'])} 
               alt={`artwork ${artwork.name}`}
               draggable={false}
               />
            </div>
            <div className={'summary-title medium-3'}>
               {artwork.title}
            </div>
         </div>
      ))}
     </div>
)

const mapStateToProps = (state, ownProps) => {
   return {
    getSelectedArtwork: getSelectedArtwork(state, ownProps),
     ...ownProps
   }
}
const mapDispatchToProps = dispatch => bindActionCreators({
   setJourneyNavStep
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtSummary)


// WEBPACK FOOTER //
// ./src/components/FinalizeJourney/ArtSummary.js